import { Component, Input } from '@angular/core';
import { Store } from '@ngxs/store';
import { LenderUserState } from 'app/store/lender-user/lender-user/lender-user.state';

@Component({
  selector: 'activity-row-deal-document-accepted',
  template: `
    <div style="float: left; margin-right: 10px; transform: translate(0px, -5px);">
      <mat-icon>person</mat-icon>
    </div>
    <div class="description">
      <strong>Document Accepted By Lender [{{ activity.meta?.institutionName }}]</strong>
      <div class="text">
        {{ activity.meta?.acceptedByUser }}
        accepted {{ activity.meta?.document?.title }} for deal {{ activity.dealId }}.
      </div>
    </div>
  `,
  styles: [],
  standalone: false
})
export class ActivityRowDealDocumentAcceptedComponent {
  lenderUser = this.store.selectSignal(LenderUserState.lenderUser);
  @Input() activity;

  constructor(
    private store: Store,
  ) {}
}
